var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ad-group-form" },
    [
      _c(
        "el-form",
        {
          ref: "adGroupForm",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-width": "120px",
            size: "small",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "广告组名称", prop: "name" } },
            [
              _c("el-input", {
                directives: [{ name: "no-emoji", rawName: "v-no-emoji" }],
                staticStyle: { width: "400px" },
                attrs: {
                  placeholder: "请输入广告组名称",
                  maxlength: "10",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          !_vm.isSimpleMode
            ? _c(
                "el-form-item",
                { attrs: { label: "展示页面", prop: "displayPage" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "400px" },
                      attrs: { placeholder: "请选择", clearable: "" },
                      model: {
                        value: _vm.form.displayPage,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "displayPage", $$v)
                        },
                        expression: "form.displayPage",
                      },
                    },
                    _vm._l(_vm.pageEnumList, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("el-form-item", { attrs: { label: "权重", prop: "weights" } }, [
            _c(
              "div",
              { staticStyle: { display: "flex", "align-items": "center" } },
              [
                _c("el-input-number", {
                  attrs: { min: 1, max: 10 },
                  model: {
                    value: _vm.form.weights,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "weights", $$v)
                    },
                    expression: "form.weights",
                  },
                }),
                _c(
                  "span",
                  { staticClass: "form-tip", staticStyle: { width: "450px" } },
                  [_vm._v(" 权重数值越小越靠前，广告组优先级越高 ")]
                ),
              ],
              1
            ),
          ]),
          !_vm.isSimpleMode
            ? _c(
                "el-form-item",
                { attrs: { label: "banner 模板", prop: "templateId" } },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "400px" },
                          attrs: {
                            placeholder: "请选择banner模板",
                            disabled: _vm.isEdit,
                          },
                          on: { change: _vm.handleTemplateChange },
                          model: {
                            value: _vm.form.templateId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "templateId", $$v)
                            },
                            expression: "form.templateId",
                          },
                        },
                        _vm._l(_vm.bannerTemplates, function (item) {
                          return _c(
                            "el-option",
                            {
                              key: item.id,
                              attrs: {
                                label: item.name,
                                value: item.id,
                                disabled: !item.selected,
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { padding: "0 20px" } },
                                [
                                  _vm._v(
                                    "\n              " + _vm._s(item.name)
                                  ),
                                  !item.selected
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            color: "red",
                                            "margin-left": "10px",
                                          },
                                        },
                                        [_vm._v("(未配置默认banner)")]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                      _vm.isEdit
                        ? _c("div", [_vm._v(_vm._s(_vm.form.adTemplateName))])
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass: "form-tip",
                          staticStyle: { width: "450px" },
                        },
                        [_vm._v(" 选用模板前需配置默认 banner ")]
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }